var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_679_1697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5938 22.9999C10.5938 20.7704 11.208 18.6818 12.2752 16.8935V9.30786H4.68952C1.67883 13.2179 0.046875 17.9833 0.046875 22.9999C0.046875 28.0165 1.67883 32.7819 4.68952 36.6919H12.2752V29.1063C11.208 27.318 10.5938 25.2294 10.5938 22.9999Z",
    fill: "#FBBD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5469 34.9531L17.2734 40.2266L22.5469 45.5C27.5636 45.5 32.3288 43.8681 36.2389 40.8574V33.2798H28.6613C26.8574 34.3508 24.76 34.9531 22.5469 34.9531Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2752 29.1064L4.68951 36.6921C5.29022 37.4726 5.94073 38.2134 6.63699 38.91C10.8867 43.1596 16.5369 45.5001 22.5469 45.5001V34.9532C18.1854 34.9532 14.3628 32.6048 12.2752 29.1064Z",
    fill: "#31AA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0469 22.9998C45.0471 21.6328 44.9238 20.2686 44.6784 18.9237L44.4806 17.8428H22.5469V28.3896H33.2214C32.2 30.422 30.6174 32.119 28.6612 33.2797L36.2388 40.8573C37.0193 40.2566 37.7602 39.6061 38.4567 38.9098C42.7064 34.66 45.0469 29.0098 45.0469 22.9998Z",
    fill: "#3C79E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9991 14.5478L31.9312 15.48L39.389 8.02229L38.4568 7.09013C34.2071 2.84044 28.5569 0.5 22.5469 0.5L17.2734 5.77344L22.5469 11.0469C25.7396 11.0469 28.7413 12.2902 30.9991 14.5478Z",
    fill: "#CF2D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5469 11.0469V0.5C16.5369 0.5 10.8867 2.84044 6.63693 7.09004C5.94063 7.78658 5.29011 8.52743 4.68945 9.30796L12.2751 16.8936C14.3628 13.3953 18.1854 11.0469 22.5469 11.0469Z",
    fill: "#EB4132"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_679_1697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.046875 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcons);
export default __webpack_public_path__ + "static/media/google_icons.2d0440b723bed9e08f345a9f0d03f7e2.svg";
export { ForwardRef as ReactComponent };